export enum StatusMedicines {
  yes = '1',
  no = '0',
}
